import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import NextGenTextBox from "./NextGenTextBox";
import ps5Logo from "assets/images/homePage/nextGenSection/logos/logo_ps5.png";
import Typography from "@material-ui/core/Typography";
import { TypographyVariant } from "@material-ui/core";
import Spacer from "components/Spacer";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: { width: "100%" },
        platformText: {
            lineHeight: 1.35,
            textAlign: "center",
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {
    typographyVariant: TypographyVariant;
}

export default function Playstation5TextBox(props: IProps) {
    const classes = useStyles();
    const { typographyVariant, className, ...rest } = props;

    return (
        <NextGenTextBox className={clsx(className, classes.root)} {...rest}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <img src={ps5Logo} alt="Playstation 5" style={{ maxWidth: 200 }} />

                <Spacer size={3} />

                <Typography className={classes.platformText} variant={typographyVariant}>
                    120fps option
                </Typography>

                <Typography className={classes.platformText} variant={typographyVariant}>
                    Faster loading
                </Typography>

                <Typography className={classes.platformText} variant={typographyVariant}>
                    Greater graphical fidelity
                </Typography>

                <Typography className={classes.platformText} variant={typographyVariant}>
                    PlayStation 4 FREE upgrade to PlayStation 5
                </Typography>

                <Typography className={classes.platformText} variant={typographyVariant}>
                    Haptic Feedback
                </Typography>

                <Typography className={classes.platformText} variant={typographyVariant}>
                    Adaptive triggers
                </Typography>
                <Spacer size={3} />
            </div>
        </NextGenTextBox>
    );
}
